import { Controller } from "@hotwired/stimulus";
import videojs from "video.js";

// to track view on a video, add the following attribute to the video tag:
// data-video-player-track-unique-view-value="true"
export default class extends Controller {
  static values = {
    videoId: Number,
    uniqueViewExists: Boolean,
    trackUniqueView: Boolean,
    duration: Number,
  };

  connect() {
    // this avoid double initialization of the video.js player
    if (!this.element.player) {
      this.initializePlayer();

      if (this.uniqueViewExistsValue) return;
      if (!this.trackUniqueViewValue) return;

      this.hasCountedView = false; // to stop the counter once we've counted the view
      this.watchedTime = 0; // Track total watch time
      this.lastUpdateTime = 0;

      this.player.on("play", () => this.startTracking());
      this.player.on("pause", () => this.stopTracking());
      this.player.on("timeupdate", () => this.trackUniqueView());
    }
  }

  initializePlayer() {
    const options = {
      controls: true,
      fluid: true,
      aspectRatio: "16:9",
    };
    this.player = videojs(this.element, options);
  }

  startTracking() {
    this.lastUpdateTime = Date.now(); // Store the time the video starts playing
  }

  stopTracking() {
    this.saveElapsedTime()
  }

  trackUniqueView() {
  this.saveElapsedTime();

  if (this.shouldCountView()) {
    this.hasCountedView = true;
    this.sendViewToDatabase();
  }
}

  shouldCountView() {
    if (this.hasCountedView === true) return;

    // If the video has a known duration, check if 75% was watched
    if (this.durationValue) {
      return this.watchedTime >= this.durationValue * 0.75;
    }
    // Otherwise, require at least 15 minutes (900 seconds) of watch time
    return this.watchedTime >= 900;
  }

  sendViewToDatabase() {
    fetch("/video_player_unique_views", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({ video_id: this.videoIdValue }),
    }).catch((error) => console.error("❌ Error:", error));
  }

  saveElapsedTime() {
    if (this.lastUpdateTime) {
      let elapsed = (Date.now() - this.lastUpdateTime) / 1000;
      this.watchedTime += elapsed;
      this.lastUpdateTime = Date.now();
    }
  }
}
